import mitt from 'mitt';
import { Strategy } from './api';

export enum EventType {
  RefreshSeasons = 'refreshSeasons',
  RefreshStrategies = 'refreshStrategies',
  ShowPricingLogic = 'showPricingLogic',
  CreateNewPriceWindow = 'createNewPriceWindow',
  // Add other events here as needed
}

type Events = {
  [EventType.RefreshSeasons]: void;
  [EventType.RefreshStrategies]: void;
  [EventType.ShowPricingLogic]: {
    strategyId: number;
    strategyObj: Strategy | null;
  };
  [EventType.CreateNewPriceWindow]: void;
  // Define other event types as needed
};

const eventBus = mitt<Events>();

export default eventBus;
